import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'randomOrder'
})
export class RandomOrderPipe implements PipeTransform {

  transform(list: Array<any>, startElement: number, endElement: number ): Array<any> {


    if (!list) {
      return list;

    } else {













      const newList = [...list.slice(startElement, endElement)];
      newList.sort(() => Math.random() - 0.5);
      return newList;
    }



  }

}